import {useEffect} from "react";
import {Control, Controller} from "react-hook-form";
import {Dropdown} from "primereact/dropdown";
import {classNames} from "primereact/utils";
import "./DropdownInput.scss";
import {RequestType} from "../../models/Request";

export interface DropdownInputProps {
    id: string;
    value: any // string | number | null;
    optionValue?: string
    optionLabel?: string
    onValueChange: (property: string, value: string) => void;
    options: any;
    filter?: boolean;
    labelText: string;
    placeholderText: string;
    control: Control;
    setValue?: any;
    errors: any;
    rules?: any;
    disabled?: boolean;
    colorType?: string;
};

export const DropdownInput = (p: DropdownInputProps) => {
    const {
        id,
        value,
        optionValue,
        optionLabel,
        onValueChange,
        options,
        filter,
        labelText,
        placeholderText,
        control,
        setValue,
        errors,
        rules,
        disabled,
        colorType
    } = p;

    useEffect(() => {
        if (setValue) setValue(labelText, value)
    }, [value]);

    return (
        <div className="dropdown-input">
            {(labelText != '') &&
                <label
                    className={classNames("dropdown-label", {
                        'p-error': errors[labelText],
                    })}
                    htmlFor={id}
                >
                    {labelText}
                </label>
            }
            <Controller
                name={labelText}
                control={control}
                rules={rules}
                render={({ field, fieldState }) => (
                    <Dropdown
                        {...field}
                        id={id}
                        placeholder={placeholderText}
                        value={value}
                        onChange={(e)=> {
                            field.onChange(e);
                            onValueChange(id, e.target.value)
                        }}
                        options={options}
                        filter={filter}
                        optionValue={optionValue}
                        optionLabel={optionLabel}
                        disabled={disabled}
                        className={classNames(
                            'dropdown-input-field',
                            { 'dropdown-input-field-request-import': colorType === RequestType.Import },
                            { 'dropdown-input-field-request-export': colorType === RequestType.Export },
                            { 'dropdown-input-field-request-relocation': colorType === RequestType.Relocation },
                            { 'p-invalid': fieldState.invalid }
                            )}
                        />
                    )}
            />
        </div>
    );
};
